import * as React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {createGlobalStyle} from 'styled-components'
import 'normalize.css';

import fonts from '../../fonts/index.js';
import favicon from '../../../assets/favicon.ico';
import './layout.css'

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Circular-Bold';
    font-style: normal;
    font-weight: normal;
    src: url(${fonts.CircularBold}) format('woff');
  }

  @font-face {
    font-family: 'Circular-Book';
    font-style: normal;
    font-weight: normal;
    src: url(${fonts.CircularBook}) format('woff');
  }
`

const Layout = ({ children }) => {
  return (
    <>
      <Helmet
        title="Chronos: Timetracking System"
        meta={[
          { name: 'description', content: 'Timetracking app and JIRA plugin for worklog reports' },
          { name: 'keywords', content: 'Chronos Timetracker, Chronos Timesheets, worklog reports, worklog tracker, manual worklogs, time tracking, timetracker, timetracking, atlassian, jira, atlassian-marketplace' },
        ]}
      >
        <link rel="icon" href={favicon} />
      </Helmet>
      <GlobalStyle />
      {children}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
